import { Stack } from "@mui/material";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useState } from "react";
import Commands from "../../commands";
import NullCheck from "components/NullCheck";
import ShowFault from "../ShowFault";
import McBoostPower from "../../commands/McBoostPower";
import Details from "./Details";
import McInfo from "../McInfo";
import { MC_SOFTWARE_TYPE } from 'config/const';
import B22MonitoringCard from 'containers/microControllers/b22/MonitoringCard';

const GroupData = ({ list }) => {
  const { bt } = useBizTypeTranslation();
  const [mcGuidCommand, setMcGuidCommand] = useState(null)
  const [faultData, setFaultData] = useState(null)
  const [openBoostPower, setOpenBoostPower] = useState(false)
  const [mcDropList, setMcDropList] = useState([])
  const [mcGuidInfo, setMcGuidInfo] = useState(null)

  const onClickMcDrop = (mc) => {
    if (mcDropList.includes(mc?.id))
      setMcDropList(prav => prav.filter(i => i !== mc?.id))
    else
      setMcDropList(prav => ([...prav, mc?.id]))
  }

  return (
    <Stack
      width="100%"
      spacing={2}
      direction="row"
      useFlexGap
      flexWrap="wrap"
      overflow="auto"
      pb={8}
      pt={{ xs: 1, md: 0 }}
      px={2}
    >
      {list?.map((mc, idx) => {
        if (mc.softwareType === MC_SOFTWARE_TYPE.B2_2) return (
          <B22MonitoringCard key={mc.id} mc={mc} expanded={mcDropList.includes(mc.id)}
            onToggle={() => onClickMcDrop(mc)} onFault={setFaultData} />
        );
        return (
          <Details
            key={idx}
            mc={mc}
            mcDropList={mcDropList}
            onClickMcDrop={onClickMcDrop}
            setFaultData={setFaultData}
            setMcGuidCommand={setMcGuidCommand}
            setMcGuidInfo={setMcGuidInfo}
          />
        );
      })}

      <NullCheck valueForCheck={mcGuidCommand}>
        <Commands
          mcGuid={mcGuidCommand}
          setMcGuid={setMcGuidCommand}
          setOpenBoostPower={setOpenBoostPower}
        />
      </NullCheck>

      <NullCheck valueForCheck={faultData}>
        <ShowFault
          data={faultData}
          setData={setFaultData}
        />
      </NullCheck>

      <NullCheck valueForCheck={openBoostPower}>
        <McBoostPower
          data={openBoostPower}
          setData={setOpenBoostPower}
        />
      </NullCheck>

      <NullCheck valueForCheck={mcGuidInfo}>
        <McInfo
          mcGuid={mcGuidInfo}
          setMcGuid={setMcGuidInfo}
          list={list}
        />
      </NullCheck>

    </Stack>
  );
};
export default GroupData;
